import API from './api'

const { REACT_APP_API_URI } = process.env;

const formatCompanyLinks = (response) => {
    let companyLinks = Object.values(response.data.data.company_links);
  
    return companyLinks.map((link) => {
        link.name = link && link.name ? link.name : '';
        link.url = link && link.url ? link.url : '';
        return link;
    });
}

class CompanyLinksApi {
    constructor(token) {
        this.api = new API(token);
        this.baseUrl = `${REACT_APP_API_URI}/admin/company-links`
    }

    all() {
        try {
            return this.api.get(this.baseUrl)
                .then((response) => {
                   return{ companyLinks: formatCompanyLinks(response)} 
                });
        } catch (error) {
            console.error(`Error listing company links. error=${error}`);
            return { companyLinks: [] };
        }
    }

    create(body) {
        try {
            return this.api.post(`${this.baseUrl}`, body)
                .then((response) => {
                    return response.data;
                });
        } catch (error) {
            console.error(`Error creating company link. error=${error}`);
            return {}
        }
    }

    delete(id) {
        try {
            return this.api.delete(`${REACT_APP_API_URI}/admin/company-link/${id}`)
                .then((response) => {
                    return response.data.data;
                });
        } catch (error) {
            console.error(`Error deleting company link. error=${error}`);
            return {}
        }
    }

}

export default CompanyLinksApi;